/**
 * Returns modified version of the input string that's split into three lines using '\n'.
 *
 * Shorter text is split into two lines, while everything less than 20 characters is returned as is.
 */
const ensureThreeLines = (text) => {
    const findIdealIndex = (sentence, idealIndex) => {
        let actualIndex = sentence.length;

        [...sentence].forEach((char, index) => {
            if (char === ' ' && Math.abs(index - idealIndex) < Math.abs(actualIndex - idealIndex)) {
                actualIndex = index;
            }
        });

        return actualIndex;
    };

    if (text.length < 20) {
        return text;
    }

    if (text.length < 40) {
        const idealIndex = findIdealIndex(text, Math.floor(text.length / 2));

        return `${text.slice(0, idealIndex)}\n${text.slice(idealIndex)}`;
    }

    const idealFirstIndex = findIdealIndex(text, Math.floor(text.length / 3));
    const idealSecondIndex = findIdealIndex(text, 2 * Math.floor(text.length / 3));

    return `${text.slice(0, idealFirstIndex)}\n${text.slice(idealFirstIndex, idealSecondIndex)}\n${text.slice(idealSecondIndex)}`;
};

/* eslint-disable-next-line import/prefer-default-export */
export { ensureThreeLines };
